import React from "react";
import { Box } from "@mui/material";

import ReviseMrqAction from "./ReviseMrqAction";
import SendToInventoryAction from "./SendToInventoryAction";
import AddToNewMrqAction from "./AddToNewMrqAction";

export default function FunctionsAfterValidation({
  plant,
  rows,
  setCompRows,
  filter,
  selectedRows,
}) {
  const showedRows = rows?.filter((row) => row.status === filter) || [];

  const selectedRowsData = rows.filter((row) => selectedRows[row.key]);

  const isDisable = Object.keys(selectedRows || {}).length === 0;

  return (
    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
      {showedRows.length > 0 && (
        <>
          {filter === "mismatch" && (
            <>
              <ReviseMrqAction
                plant={plant}
                selectedRowsData={selectedRowsData}
                disabled={isDisable}
              />

              <SendToInventoryAction
                selectedRowsData={selectedRowsData}
                setCompRows={setCompRows}
                selectedRows={selectedRows}
                disabled={isDisable}
              />
            </>
          )}

          {filter === "left-only" && (
            <SendToInventoryAction
              selectedRowsData={selectedRowsData}
              setCompRows={setCompRows}
              selectedRows={selectedRows}
              disabled={isDisable}
            />
          )}

          {filter === "right-only" && (
            <AddToNewMrqAction
              plant={plant}
              selectedRowsData={selectedRowsData}
              disabled={isDisable}
            />
          )}
        </>
      )}
    </Box>
  );
}
